// extracted by mini-css-extract-plugin
export default {"modal__overlay":"styles_modal__overlay__MA-qe"};